<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <multiselect
        :clear-on-select="!multiple"
        :close-on-select="!multiple"
        :custom-label="fullLabel"
        :hide-selected="multiple"
        :internal-search="false"
        :limit="3"
        :loading="!ready"
        :multiple="multiple"
        :options="options"
        :options-limit="50"
        :placeholder="placeholder.length > 0 ? placeholder : 'Type to search'"
        :preserve-search="multiple"
        :show-labels="false"
        :value="value"
        label="job"
        track-by="id"
        @input="update"
        @search-change="asyncFind"
      >
        <template #noResult>
          <slot name="no-result">Oops! No result found.</slot>
        </template>
      </multiselect>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import debounce from "debounce";
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    jobId: {
      type: Number,
      required: false,
      default: null,
    },
    filterByTechnician: {
      type: Number,
      required: false,
      default: null,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    resetUser() {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", null);
    },

    update(object) {
      if (object !== undefined && object !== null && this.form) {
        this.form[this.name] = object.id;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },

    fullLabel(job) {
      if (job && job.id) {
        return `${job.formatted_job_number} ${job.customer.primary_contact.name} [${job.brand.name}]`;
      }

      return "";
    },

    /* eslint-disable func-names */
    asyncFind: debounce(function (query) {
      if (query.length < 2) {
        return;
      }

      this.ready = false;

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      const filter = this.filterByTechnician ? `&technicianId=${this.filterByTechnician}` : "";

      this.$http
        .get(
          `/jobs?search=${query}&fullSearch=true&category=id&with=brand;customer.primaryContact&limit=50${filter}`
        )
        .then((response) => {
          this.options = response.body.data;
          this.ready = true;
        });
    }, 500),
  },
};
</script>
